// extracted by mini-css-extract-plugin
module.exports = {"column":"DataFormatSelection_column__1fexb","row":"DataFormatSelection_row__21IH3"};